import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const categories = [{
  title: 'TOPS Y BLUSAS',
  description: 'Patrones modernos para crear prendas únicas y actuales.',
  count: 'Más de 600 patrones incluidos',
  image: 'https://cdn.magicpatterns.com/uploads/pHnnnC1wN4ztimuGaekKGx/crochet_tops_hero_180kb.webp'
}, {
  title: 'BEBÉS Y NIÑOS',
  description: 'Ropa, accesorios y proyectos adorables para los más pequeños.',
  count: 'Más de 850 patrones incluidos',
  image: 'https://cdn.magicpatterns.com/uploads/wnmG5DiydoqpRNGfY6zzko/crochet_bebes_hero.webp'
}, {
  title: 'AMIGURUMIS',
  description: 'Muñecos, personajes y creaciones que enamoran a primera vista.',
  count: 'Más de 1.200 patrones incluidos',
  image: 'https://cdn.magicpatterns.com/uploads/h1GXJpr9a2rgxfB5cxNYgP/amigurumis_fondo_beige.webp'
}, {
  title: 'DECO HOGAR',
  description: 'Transformá cualquier espacio con piezas tejidas llenas de estilo.',
  count: 'Más de 500 patrones incluidos',
  image: 'https://cdn.magicpatterns.com/uploads/nqohCknMdpQErx2p4dCp7X/crochet_hogar_fondo_beige.webp'
}, {
  title: 'SWEATERS Y CARDIGANS',
  description: 'Diseños premium para usar, regalar o vender.',
  count: 'Más de 450 patrones incluidos',
  image: 'https://cdn.magicpatterns.com/uploads/no5qYBVmz4mgh4gXYuXPjA/ChatGPT_Image_4_jun_2026,_22_21_32.webp'
}];
export function Categories() {
  return <section className="py-14 px-6 bg-cream/30" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <div className="text-center mb-12" data-id="element-53">
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-3" data-id="element-54">
            UNA BIBLIOTECA{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-55">COMPLETA</span>{' '}
            DE CROCHET
          </h2>
          <p className="text-lg text-dark/80 max-w-2xl mx-auto font-medium" data-id="element-56">
            Todo lo que te imagines, listo para tejer. Más de 4.000 patrones
            organizados por categoría.
          </p>
        </div>

        <div className="space-y-12 mb-12" data-id="element-57">
          {categories.map((cat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center text-center" data-id="element-58">
              <h3 className="text-2xl md:text-4xl font-bold text-dark mb-2 tracking-wide" data-id="element-59">
                {cat.title}
              </h3>
              <p className="text-base md:text-lg text-dark/70 mb-6 max-w-xl" data-id="element-60">
                {cat.description}
              </p>

              <div className="w-full max-w-lg mx-auto rounded-2xl overflow-hidden shadow-soft border border-rose-light/20" data-id="element-61">
                <img src={cat.image} alt={`Patrones de ${cat.title}`} className="w-full h-auto object-cover block" loading="lazy" decoding="async" data-id="element-62" />
              </div>

              <div className="mt-2 bg-rose-light/20 border border-rose-light/50 text-rose-deep font-bold px-5 py-2 rounded-full text-sm md:text-base shadow-sm" data-id="element-63">
                {cat.count}
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-64">
          <CTAButton data-id="element-65" />
        </div>
      </div>
    </section>;
}